import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Standalone } = await import('./index');
    return {
        Component: Standalone,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
